/**
 * @generated SignedSource<<414a0515065853d20f18ac305c849874>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useMemberShouldOnboardQuery$variables = {
  membershipId: string;
};
export type useMemberShouldOnboardQuery$data = {
  readonly membership: {
    readonly hasSeenOnboarding?: boolean;
    readonly id?: string;
    readonly viewerShouldCompleteMemberOnboarding?: boolean;
  } | null;
};
export type useMemberShouldOnboardQuery = {
  response: useMemberShouldOnboardQuery$data;
  variables: useMemberShouldOnboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "membershipId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "membershipId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSeenOnboarding",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerShouldCompleteMemberOnboarding",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMemberShouldOnboardQuery",
    "selections": [
      {
        "alias": "membership",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMemberShouldOnboardQuery",
    "selections": [
      {
        "alias": "membership",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fb888fb701d570121922468d87dd5601",
    "id": null,
    "metadata": {},
    "name": "useMemberShouldOnboardQuery",
    "operationKind": "query",
    "text": "query useMemberShouldOnboardQuery(\n  $membershipId: ID!\n) {\n  membership: node(id: $membershipId) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      hasSeenOnboarding\n      viewerShouldCompleteMemberOnboarding\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7866dc13e9db930df4fc3f9e05424081";

export default node;
